/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Rule_Sets_HiddenInputs */

const en_tables_rule_sets_hidden = /** @type {(inputs: Tables_Rule_Sets_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets Hidden`)
};

const de_tables_rule_sets_hidden = /** @type {(inputs: Tables_Rule_Sets_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist ausgeblendet`)
};

/**
* | output |
* | --- |
* | "Sets Hidden" |
*
* @param {Tables_Rule_Sets_HiddenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_rule_sets_hidden = /** @type {((inputs?: Tables_Rule_Sets_HiddenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Rule_Sets_HiddenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_rule_sets_hidden(inputs)
	return de_tables_rule_sets_hidden(inputs)
});